import { Menu } from '@mui/material'
import clsx from 'clsx'
import { useRef, useState } from 'react'
import { Link } from 'react-router-dom'

import LogoutIcon from '@/assets/log-out.svg?react'
import { RotatingChevronIcon, Rule, Typography } from '@/components/core-v2'
import { DownloadLink, onDownloadLinkClick } from '@/components/core-v2/molecules/download-link'
import { PATH } from '@/const'
import { useLogout } from '@/utilities/hooks/useLogout'
import { useUser } from '@/utilities/hooks/useUser'

import classes from './UserMenu.module.scss'

export const UserMenu = () => {
  const { data: user } = useUser()

  const buttonRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  const [mutateLogout] = useLogout()

  const closeMenu = () => setIsOpen(false)
  const toggleMenu = () => setIsOpen(isOpen => !isOpen)

  if (!user) return null
  const fullName = `${user.firstName} ${user.lastName}`

  return (
    <div>
      <button
        ref={buttonRef}
        data-private
        aria-controls="user-menu"
        aria-haspopup="true"
        className={clsx(classes.button, 'center')}
        type="button"
        onClick={toggleMenu}
      >
        {fullName}
        <RotatingChevronIcon classNames={{ root: classes.chevron }} isRotated={isOpen} />
      </button>
      <Menu
        keepMounted
        anchorEl={buttonRef?.current}
        classes={{ paper: clsx(classes.menu, { [classes.menuOpen]: isOpen }) }}
        id="user-menu"
        open={isOpen}
        onClose={closeMenu}
      >
        <div className={classes.profileInformation}>
          <Typography data-private variant="b2">
            {user.firstName} {user.lastName}
          </Typography>
          <Typography data-private color="white60" variant="b2">
            {user.roles[0]}
          </Typography>
        </div>

        <Rule className="mb-3" />
        <li>
          <Link to={PATH.changePassword} onClick={closeMenu}>
            Change password
          </Link>
        </li>
        <li>
          <DownloadLink
            onClick={() =>
              onDownloadLinkClick({
                url: '/api/absa/documentation/AbsaPlatformTCs.pdf'
              })
            }
          >
            Terms and conditions
          </DownloadLink>
        </li>
        <Rule className="my-3" />
        <li>
          <button type="button" onClick={mutateLogout}>
            <LogoutIcon /> Log out
          </button>
        </li>
      </Menu>
    </div>
  )
}
